import { CalendarDays, ChartNoAxesColumn, History, House, SquarePen } from 'lucide-react';
import type { ModuleNavItem } from '@/components/ModuleNavbar';

/** Gestão (`manage`) vê tudo; corretor (`agendar`) só registra e vê o próprio histórico. */
export const VISITAS_GESTAO = 'visitas.manage';
export const VISITAS_PORTAL = [VISITAS_GESTAO, 'visitas.agendar'];

export const VISITAS_NAV_ITEMS: ModuleNavItem[] = [
    { label: '', path: '/apps', end: true, icon: <House className="h-4 w-4" /> },
    { label: 'Painel', path: '/visitas', end: true, icon: <ChartNoAxesColumn className="h-4 w-4" />, permission: VISITAS_GESTAO },
    { label: 'Registrar', path: '/visitas/registrar', icon: <SquarePen className="h-4 w-4" />, anyOf: VISITAS_PORTAL },
    { label: 'Agenda', path: '/visitas/agenda', icon: <CalendarDays className="h-4 w-4" />, permission: VISITAS_GESTAO },
    { label: 'Histórico', path: '/visitas/historico', icon: <History className="h-4 w-4" />, anyOf: VISITAS_PORTAL },
];
